import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavbar from '../Navbar/Navbar';
import '../../index.css';
import Sidebar from '../../screens/AdminPanel/Sidebar';

const AdminLayout = () => {

  return (
    <div>
      <header>
        <AdminNavbar />
      </header>
      <main>
        <Sidebar />
        <Outlet mi />
      </main>
      <footer>
        {/* Add your admin footer here */}
      </footer>
    </div>
  );
};

export default AdminLayout;
